module.exports = __webpack_public_path__ + "static/img/9.6680297.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/sp/9.png
// module id = sg8R
// module chunks = 0